export const OthersFeesType = {
    PENALTY : "PENALTY",
    RESIDUAL : "RESIDUAL"
  };


// WEBPACK FOOTER //
// ./src/const/OthersFeesType.js